<template>
    <span class="time-counter">{{day}}天{{hr}}时{{min}}分{{sec}}秒</span>
</template>

<script>
    export default {
        name: 'timeCounter',
        props: {
            nowTime: {
                type: String,
                default: new Date()
            },
            endTime: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                currTimeStamp:Date.parse(this.nowTime),
                day:'0',
                hr:'00',
                min:'00',
                sec:'00',
                countDownInterval:null
            }
        },
        computed: {
            nowTimeStamp(){
                return this.nowTime;
            },
            endTimeStamp(){
                return this.endTime;
            }
        },
        mounted(){
            this.countdown();
        },
        methods: {
            //倒计时
            countdown() {
                let end = Date.parse(this.endTime);
                this.currTimeStamp=this.currTimeStamp+1000;
                let msec = end - this.currTimeStamp;
                if (msec >= 0) {
                    let day = parseInt(msec / 1000 / 60 / 60 / 24);
                    let hr = parseInt(msec / 1000 / 60 / 60 % 24);
                    let min = parseInt(msec / 1000 / 60 % 60);
                    let sec = parseInt(msec / 1000 % 60);
                    this.day = day;
                    this.hr = hr > 9 ? hr : '0' + hr;
                    this.min = min > 9 ? min : '0' + min;
                    this.sec = sec > 9 ? sec : '0' + sec;
                }else {
                    this.day = '0';
                    this.hr = '00';
                    this.min = '00';
                    this.sec = '00';
                }
                const that = this;
                this.countDownInterval=setTimeout(function () {
                    if (msec === 0) {
                        clearInterval(that.countDownInterval);
                    }
                    that.countdown()
                }, 1000);
            }
        },
        beforeDestroy(){
            clearTimeout(this.countDownInterval);
        }
    }
</script>

<style scoped lang="scss">

</style>